export const supportedProviders = [
  {
    name: '-- Choose provider --',
    code: 'none',
  },
  {
    name: 'Belgium ID card login',
    code: 'be-id-login',
  },
  {
    name: 'eDO App login',
    code: 'edoapp-eid-login',
  },
  {
    name: 'eParaksts Mobile login',
    code: 'lv-eparaksts-mobile-login',
  },
  {
    name: 'eParaksts Smart Card',
    code: 'lv-eparaksts-id-login',
  },
  {
    name: 'Estonian ID card login',
    code: 'ee-web-eid-login',
  },
  {
    name: 'Estonian Mobile ID',
    code: 'mid-login',
  },
  {
    name: 'Evrotrust',
    code: 'evrotrust-login',
  },
  {
    name: 'Finnish Henkilökortti',
    code: 'fi-id-login',
  },
  {
    name: 'ID Austria - Handysignatur A-Trust',
    code: 'at-handy-signatur-login',
  },
  {
    name: 'Itsme login',
    code: 'itsme-login',
  },
  {
    name: 'Lithuanian ID Card',
    code: 'lt-id-login',
  },
  {
    name: 'Lithuanian Mobile ID',
    code: 'lt-mobile-id',
  },
  {
    name: 'MitID Login',
    code: 'mit-id-login',
  },
  {
    name: 'MojeID login',
    code: 'mojeid',
  },
  {
    name: 'OneID',
    code: 'gb-one-id-login',
  },
  {
    name: 'Portuguese Cartão de Cidadão',
    code: 'pt-id-login',
  },
  {
    name: 'Serbian ID Card',
    code: 'rs-id-login',
  },
  {
    name: 'Smart-ID login',
    code: 'smartid',
  },
  {
    name: 'Swedish Bank ID',
    code: 'swedish-bankid-login',
  },
  {
    name: 'Veriff Login',
    code: 'veriff-login',
  },
];
